/**
 * Die Menge eines Postens in der Merkliste (V-22, Durchgang 03.10.2026).
 *
 * Eine Textzeile hat keine; eine Leistung, deren Menge erst aus dem Aufmaß
 * folgt (`needs_site_survey`), hat 0, bis jemand eine einträgt — eine Eins
 * sähe aus wie ein gemessener Quadratmeter und würde mit der Annahme als Ist
 * eingefroren (Regel 3). Überall sonst ist mindestens eins gemeint.
 *
 * **Eine Leistung trägt zwei Nachkommastellen** (08.10.2026): 580,5 m² oder
 * 1,5 Stunden sind Mengen, keine Stückzahlen. Bis dahin rundete auch sie auf
 * ganze Zahlen — „1,5 Stunden" wurde beim nächsten Lesen zu 2. Eine Miete, eine
 * Ware und ein Zuschlag zählen weiter ganze Stücke.
 */
export function postenmenge(
  art: "miete" | "leistung" | "verkauf" | "zuschlag" | "text",
  menge: number | undefined,
  aufmass: boolean,
): number {
  if (art === "text") return 0;
  if (art === "leistung") {
    const genannt = menge !== undefined && Number.isFinite(menge) ? Math.round(menge * 100) / 100 : 0;
    if (genannt > 0) return genannt;
    return aufmass ? 0 : 1;
  }
  return Math.max(1, Math.round(menge ?? 1));
}
